import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_LANDING_PAGE_STATE,
});

export const syncLandingPages = () => ({
  type: types.SYNC_LANDING_PAGES.REQUEST,
});

export const syncLandingPagesSuccess = (pages) => ({
  type: types.SYNC_LANDING_PAGES.SUCCESS,
  pages,
});

export const syncLandingPagesFailure = (error) => ({
  type: types.SYNC_LANDING_PAGES.FAILURE,
  error,
});

export const saveLandingPage = (page) => ({
  type: types.SAVE_LANDING_PAGE.REQUEST,
  page,
});

export const saveLandingPageSuccess = (landingId, publicUrl) => ({
  type: types.SAVE_LANDING_PAGE.SUCCESS,
  landingId,
  publicUrl,
});

export const saveLandingPageFailure = (error) => ({
  type: types.SAVE_LANDING_PAGE.FAILURE,
  error,
});

export const archiveLandingPage = (landingId) => ({
  type: types.ARCHIVE_LANDING_PAGE.REQUEST,
  landingId,
});

export const archiveLandingPageSuccess = () => ({
  type: types.ARCHIVE_LANDING_PAGE.SUCCESS,
});

export const archiveLandingPageFailure = (error) => ({
  type: types.ARCHIVE_LANDING_PAGE.FAILURE,
  error,
});
